import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { MatSnackBar } from "@angular/material";
import { environment } from '../../environments/environment';

import { EspectaculoService } from '../services/espectaculo.service';
import { Espectaculo } from '../models/espectaculo';
import { EspectaculoEditorComponent } from '../espectaculo-editor/espectaculo-editor.component';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
@Component({
  selector: 'app-espectaculo-list',
  templateUrl: './espectaculo-list.component.html',
  styleUrls: ['./espectaculo-list.component.css']
})
export class EspectaculoListComponent implements OnInit {


  models: Espectaculo[];
  Url = environment.imgUrl;

  constructor(private modelService: EspectaculoService, public dialog: MatDialog, private snackBar: MatSnackBar) {
    this.models = [];
  }

  ngOnInit() {
    this.getAll();
  }

  openEditor(id) {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '600px';
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      id: id
    };

    const dialogRef = this.dialog.open(EspectaculoEditorComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(
      data => {
        this.getAll();

      }
    );
  }

  delete(id) {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '300px';

    const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(
      data => {
        if (data == true) {
          this.modelService.delete(id).subscribe(
            val => {
              this.getAll();
              this.snackBar.open('Registro Eliminado', '', {
                duration: 2000,
              });
            });
        }
      }
    );

  }

  getAll() {

    let filter = {
    }

    this.modelService.getFilter(filter).subscribe(val => {
      this.models = val;

    },
      error => {
        console.log(error);
        console.log(<any>error);
      });

  }


  destacado(id, destacado) {

    let change = {
      id: id,
      destacado: destacado
    }
    this.modelService.destacado(change, id).subscribe(
      val => {
        if (val.status == true) {
          this.getAll();
          this.snackBar.open(val.message, '', {
            duration: 2000,
          });
        }
        else {
          this.snackBar.open(val.message, '', {
            duration: 2000,
            panelClass: ['red-snackbar']
          });
        }

      },
      error => {
        console.log(<any>error);
        this.snackBar.open('Intente de nuevo, ocurrio un error', '', {
          duration: 3000,
          panelClass: ['red-snackbar']
        });
      });
  }
}
